import { DividedContainerProps } from 'layout/divided-container/divided-container.props';

export const DividedContainerPresets: DividedContainerProps = {
  leftContent: null,
  leftContentProps: {
    backgroundColor: 'cream',
    padding: 's5',
  },
  rightContent: null,
  rightContentProps: {
    padding: 's5',
  },
};
